import {Link, useParams} from "react-router-dom";
import {TutorialsData} from "../../../helpers/data-jsons";
import {Box, Flex, Heading, Image, Stack, VStack} from "@chakra-ui/react";
import {ReactComponent as Back} from "../../../assets/icons/back.svg";

const TutorialView = () => {
    const {id} = useParams(); // from react-router
    const {subId} = useParams(); // from react-router
    const tutorial = TutorialsData.find((b) => Number(b.id) === Number(id))
    const lessson = tutorial.lesson.find((i) => Number(i.id) === Number(subId))
    return (
        <Stack
            maxW={'1344px'}
            m={'auto'}
            p={{base: '24px 0', md: '24px 16px'}}
            gap={'24px'}
        >
            <Heading
                display={'flex'}
                alignItems={'center'}
                gap={'4px'}
                width={{base: '95%', md: 'full'}}
                margin={'auto'}
                textAlign={'start'}
                color={'neutral.100'}
                fontSize={'heading.3xl'}
            >
                <Box
                    as={Link}
                    to={'/tutorials'}
                >
                    <Back/>
                </Box>
                Tutorials</Heading>
            <Box
                display={'flex'}
                flexDirection={'column'}
                gap={'32px'}
                w={'full'}
                margin={'auto'}
                bg={'neutral.1100'}
                p={{base: '24px 16px', md: '24px 32px'}}
                borderRadius={{base: '0', md: '16px'}}>
                <VStack
                    flexDirection={'column'}
                    alignItems={'flex-start'}
                    color={'neutral.500'}>
                    <Heading
                        display={{base: 'none', md: 'block'}}
                        fontSize={'24px'}
                        fontWeight={'400'}
                    >{tutorial.title}</Heading>
                    <Flex
                        flexDirection={{base: 'column', md: 'row'}}
                        alignItems={{base:'flex-start',md:'center'}}
                        gap={'16px'}
                    >
                        <Box
                            color={'purple.500'}
                            fontSize={'24px'}
                            fontWeight={'700'}
                        >Lesson:{lessson.number}</Box>
                        <Box
                            fontSize={'18px'}
                            fontWeight={'400'}
                            color={'neutral.100'}
                        >{lessson.title}</Box>
                    </Flex>
                </VStack>
                <Box>
                    <Image maxH={'355px'}
                           borderTopLeftRadius={'16px'}
                           borderTopRightRadius={'16px'}
                           w={'full'}
                           objectFit={'cover'}
                           src={'/images/' + lessson.imgUrl}/>
                </Box>
                <Box
                    color={'neutral.100'}
                    display={'flex'}
                    flexDirection={'column'}
                    gap={'16px'}
                >
                    {lessson.text}
                </Box>
            </Box>
        </Stack>
    )
}
export default TutorialView